import React from "react";
import { logoFor } from "@/lib/companies";

export default function CompanyBadge({ name, size = "sm", showLabel = true }) {
  if (!name) return null;
  const logo = logoFor(name);
  const h = size === "sm" ? "h-4" : size === "md" ? "h-5" : "h-6";
  return (
    <span className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
      {logo && <img src={logo} alt={name} className={`${h} w-auto object-contain`} />}
      {showLabel && <span>{name}</span>}
    </span>
  );
}
